export default "__VITE_ASSET__D9C$2qvN__"